import { useMsal } from '@azure/msal-react';

export const useAuthService = () => {
  const { instance } = useMsal();

  const logout = async () => {
    try {
      console.log('🚪 [SSO] Starting MSAL logout redirect...');
      
      // Use redirect instead of popup for cleaner logout experience
      // This does a full page redirect, no popup needed
      await instance.logoutRedirect({
        postLogoutRedirectUri: '/'
      });
      
      console.log('✅ [SSO] MSAL logout redirect initiated');
    } catch (error) {
      console.error('❌ [SSO] Logout redirect failed:', error);
      
      // Fallback: Force clear MSAL cache and session storage
      try {
        // Clear all MSAL accounts
        const accounts = instance.getAllAccounts();
        accounts.forEach(account => {
          instance.setActiveAccount(null);
        });
        
        // Clear session storage (MSAL cache)
        sessionStorage.clear();
        
        // Force redirect to landing page
        window.location.href = '/';
        
        console.log('✅ [SSO] Forced MSAL session cleanup and redirect completed');
      } catch (cleanupError) {
        console.error('❌ [SSO] Session cleanup failed:', cleanupError);
        // Last resort - just redirect
        window.location.href = '/';
      }
    }
  };

  const getCurrentUser = () => {
    const account = instance.getActiveAccount();
    return account ? {
      name: account.name || account.username,
      email: account.username,
      isAuthenticated: true
    } : null;
  };

  return {
    logout,
    getCurrentUser
  };
};
